<template>
    <div class="stat-box">
        <div class="stat-header top20">
            <div class="stat-header-info" v-for="(item,index) in statdata" :key="index" >
                <span>{{item.nums}}</span>
                <h class="top05">{{item.name}}</h>
            </div>
        </div>

        <!-- 24小时流量情况 -->
        <div class="TTL-content-list top70">
            <span class="TTL-content-list-title">今日流量（小程序访问点击率）</span>
            <div class="TTL-pie-infos-tu" :ref="houerobj.ref" />
        </div>


    </div>
</template>

<script>
import INTERFACE_MODEL_STAT from '@/Interface/Shop/stat';
import * as echarts from 'echarts';
export default {

    components:{
        
    },

    data() {
        return {
            statdata:[], //日数据统计   
            //24小时流量数据
            houerobj: {
                ref:'houerobj',
                option: {
                    xAxis: {
                        type: 'category',
                        data: []
                    },
                    yAxis: {
                        type: 'value'
                    },
                    series: [
                        {
                            data: [],
                            type: 'line',
                            smooth: true
                        }
                    ]
                },
            },  
        }
    },

    mounted() {

        this.OnloadMethod(false); //页数初始化

    },

    methods: {


        /** 修改页面显示标签信息 **/
        ChangePageLabel() {
            
        },


        /** 页数初始化 **/
        OnloadMethod(isfresh) {
            this.GetStatDay();
            this.GetStatFlows();
        },


        /** 其它组件调用当前组件进行数据传递 **/
        BrotherComponentIn(data) {
            if(data.isask) { //组件已存在，同级兄弟元素调用时产生的操作
                
            }else if(data.reload) { //浏览器重新刷新时执行的操作
                
            }else {
                this.GetStatDay();
                this.GetStatFlows();
            }
        },

        /**
         * 获取日数据统计
        */
        GetStatDay() {
            INTERFACE_MODEL_STAT.GET_SHOP_INFO().then((res) => {
                 if(res.status > 0) return false;
                 this.statdata=res.data;
            });
        },

        /**
         * 今日24小时流量数据
        */
        GetStatFlows() {
            INTERFACE_MODEL_STAT.GET_STAT_FLOW_HOURS_INFO().then((res) => {
                 if(res.status > 0) return false;
                 var flowdata=res.data;
                 this.houerobj.option.xAxis.data=flowdata.time;
                 this.houerobj.option.series[0].data=flowdata.data;

                 var flowDom = this.$refs[this.houerobj.ref];
                 var flowChart = echarts.init(flowDom);
                 flowChart.setOption(this.houerobj.option);
            });
        },
        

    },
}
</script>
<style scoped>
.stat-box {
    display: inline-block;
    width: 100%;
}
.stat-header {
    display: inline-block;
    width: 100%;
}
.stat-header-info {
   display: inline-block;
   width:calc(100% / 7); 
   padding: 10px 0;
}
.stat-header-info span {
   display: inline-block;
   width: 100%;
   text-align: center; 
   font-size: 18px;
   line-height: 18px;
   font-weight: bold;
   color:#666eeb;
}
.stat-header-info h {
   display: inline-block;
   width: 100%;
   text-align: center;
   font-size: 12px;
   color:#999999;
}
.TTL-content-list {display: inline-block;width:100%;}
.TTL-content-list-title {display: inline-block;width:100%;font-size:13px;text-align: center;color:#666666;}
.TTL-pie-infos-tu {display: inline-flex;justify-content: center;align-items: center;width:100%;height:300px;}
.TTL-pie-title {font-size:13px;color:#503b11;display: inline-block;width:100%;text-align: center;}
.TTL-content-list-info {display: inline-block;width:50%;}
.TTL-goods-list-box {display: inline-block;width:100%;height: 370px;overflow-y: auto;}
.TTL-goods-list-box::-webkit-scrollbar {width:0;}
.box-center {display: inline-flex;justify-content: center;align-items: flex-start;}
</style>